<div class="flex flex-col">
  <div class="flex items-center justify-between">
    <div class="flex items-center gap-2">
      @if (!isMobile()) {
        <proffeo-ui-button
          (clicked)="emitApproveReports()"
          [disabled]="selectedTimeReportIds().length === 0"
          variant="primary"
          fontIcon="done_all"
          text="time-reports-mark-as.mark-as-approved"
        ></proffeo-ui-button>
      }

      <proffeo-time-report-excel-export
        [timeReportRows]="timeReportRows()"
        [visibleTableColumns]="visibleTableColumns()"
      ></proffeo-time-report-excel-export>

      @if (isMobile()) {
        <proffeo-ui-button
          #menuTrigger="matMenuTrigger"
          [matMenuTriggerFor]="groupingMenu"
          [ariaLabel]="'time-reports-grouping.group-by-button'"
          variant="ghost"
          fontIcon="subdirectory_arrow_right"
          class="shrink-0"
        />
      } @else {
        <proffeo-ui-button
          #menuTrigger2="matMenuTrigger"
          [matMenuTriggerFor]="groupingMenu"
          [fontIcon]="'subdirectory_arrow_right'"
          variant="primary"
          text="time-reports-grouping.group-by-button"
        ></proffeo-ui-button>
      }

      <mat-menu #groupingMenu="matMenu">
        <button
          (click)="emitChangeGroupingMode(GroupingModeEnum.NONE)"
          [class.bg-proffeo-surface-selected]="selectedGroupingMode() === GroupingModeEnum.NONE"
          mat-menu-item
        >
          <mat-icon fontIcon="format_align_right" />
          <span>{{ 'time-reports-grouping.group-by-none' | translate }}</span>
        </button>

        <button
          (click)="emitChangeGroupingMode(GroupingModeEnum.DATE)"
          [class.bg-proffeo-surface-selected]="selectedGroupingMode() === GroupingModeEnum.DATE"
          mat-menu-item
        >
          <mat-icon fontIcon="calendar_month" />
          <span>{{ 'time-reports-grouping.group-by-date' | translate }}</span>
        </button>

        <button
          (click)="emitChangeGroupingMode(GroupingModeEnum.USER)"
          [class.bg-proffeo-surface-selected]="selectedGroupingMode() === GroupingModeEnum.USER"
          mat-menu-item
        >
          <mat-icon fontIcon="person" />
          <span>{{ 'time-reports-grouping.group-by-user' | translate }}</span>
        </button>

        <button
          (click)="emitChangeGroupingMode(GroupingModeEnum.USER_DATE)"
          [class.bg-proffeo-surface-selected]="selectedGroupingMode() === GroupingModeEnum.USER_DATE"
          mat-menu-item
        >
          <mat-icon fontIcon="perm_contact_calendar" />
          <span>{{ 'time-reports-grouping.group-by-user-and-date' | translate }}</span>
        </button>

        <button
          (click)="emitChangeGroupingMode(GroupingModeEnum.TASK)"
          [class.bg-proffeo-surface-selected]="selectedGroupingMode() === GroupingModeEnum.TASK"
          mat-menu-item
        >
          <mat-icon fontIcon="task" />
          <span>{{ 'time-reports-grouping.group-by-task' | translate }}</span>
        </button>

        <button
          (click)="emitChangeGroupingMode(GroupingModeEnum.PROJECT)"
          [class.bg-proffeo-surface-selected]="selectedGroupingMode() === GroupingModeEnum.PROJECT"
          mat-menu-item
        >
          <mat-icon fontIcon="dashboard" />
          <span>{{ 'time-reports-grouping.group-by-project' | translate }}</span>
        </button>

        <button
          (click)="emitChangeGroupingMode(GroupingModeEnum.COMPANY)"
          [class.bg-proffeo-surface-selected]="selectedGroupingMode() === GroupingModeEnum.COMPANY"
          mat-menu-item
        >
          <mat-icon fontIcon="apartment" />
          <span>{{ 'time-reports-grouping.group-by-company' | translate }}</span>
        </button>

        <button
          (click)="emitChangeGroupingMode(GroupingModeEnum.TYPE)"
          [class.bg-proffeo-surface-selected]="selectedGroupingMode() === GroupingModeEnum.TYPE"
          mat-menu-item
        >
          <mat-icon fontIcon="category" />
          <span>{{ 'time-reports-grouping.group-by-type' | translate }}</span>
        </button>
      </mat-menu>

      @if (selectedGroupingMode() !== GroupingModeEnum.NONE) {
        @if (isMobile()) {
          <proffeo-ui-button
            (clicked)="sessionsToggled() ? hideAll.emit() : expandAll.emit()"
            [fontIcon]="sessionsToggled() ? 'unfold_less' : 'unfold_more'"
            [ariaLabel]="sessionsToggled() ? 'time-reports-toolbar.collapse-all' : 'time-reports-toolbar.expand-all'"
            variant="ghost"
            class="shrink-0"
          />
        } @else {
          <proffeo-ui-button
            (clicked)="sessionsToggled() ? hideAll.emit() : expandAll.emit()"
            [fontIcon]="sessionsToggled() ? 'unfold_less' : 'unfold_more'"
            [text]="sessionsToggled() ? 'time-reports-toolbar.collapse-all' : 'time-reports-toolbar.expand-all'"
            variant="primary"
          ></proffeo-ui-button>
        }
      }
    </div>

    <div class="flex items-center gap-2">
      @if (isMobile()) {
        <proffeo-ui-button
          (clicked)="onClearFilters()"
          [ariaLabel]="'time-reports-filters.clear-filters'"
          variant="ghost"
          fontIcon="filter_list_off"
          class="shrink-0"
        />

        <proffeo-ui-button
          (clicked)="toggleFilters(!showFilters())"
          [ariaLabel]="'task-filters.filters'"
          variant="ghost"
          fontIcon="filter_list"
          class="shrink-0"
        />
      }

      @if (!isMobile()) {
        <proffeo-ui-button
          (clicked)="emitReport()"
          variant="primary"
          fontIcon="add"
          text="time-reports-toolbar.add-report"
        ></proffeo-ui-button>
      }
    </div>
  </div>

  @if (isMobile()) {
    <proffeo-time-report-filters-expand
      (filtersSearch)="applyFilters.emit()"
      (collapse)="toggleFilters(false)"
      [expanded]="showFilters()"
    ></proffeo-time-report-filters-expand>
  }
</div>

@if (isMobile()) {
  <proffeo-ui-button
    (clicked)="emitReport()"
    variant="accent"
    fontIcon="add"
    class="z-50 fixed bottom-5 right-5"
  />
}
